import Typography from '@/common/components/base/typography/Typography';
import LikeIcon from '@/modules/Education/assets/icons/like.svg?react';
import SeenIcon from '@/modules/Education/assets/icons/seen.svg?react';
import SolidLikeIcon from '@/modules/Education/assets/icons/solid-like.svg?react';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import { useRelativeTime } from '../../hooks/useRelativeTime';
import { GetEducationDetailQueryResponseType } from '../../queries/getEducationDetail/getEducationDetailQuery.type';
import { getEducationDetailQueryOptions } from '../../queries/getEducationDetail/getEducationDetailQueryOptions';
import { useLikeEducationQueryOptions } from '../../queries/likeEducation/likeEducationQueryOptions';
import { useViewEducationQueryOptions } from '../../queries/viewEducation/viewEducationQueryOptions';

export default function EducationMeta({
  data,
}: {
  data: GetEducationDetailQueryResponseType;
}) {
  const { id } = useParams();
  const timeAgo = useRelativeTime(data.published_at);
  const { mutate: likeMutate, isPending: isLikePending } =
    useLikeEducationQueryOptions();
  const { mutate: viewEducationMutate } = useViewEducationQueryOptions();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!id) return;
    viewEducationMutate({ id: Number(id) });
    queryClient.invalidateQueries({
      queryKey: getEducationDetailQueryOptions({ id: id! }).queryKey,
    });
  }, [id, queryClient, viewEducationMutate]);

  const handleLike = () => {
    if (!id || isLikePending) return;
    likeMutate({ id: Number(id) });
  };

  return (
    <Flex justifyContent="space-between" alignItems="center" mt={12}>
      <Flex alignItems="center" gap={4} onClick={handleLike}>
        {data?.liked ? <SolidLikeIcon /> : <LikeIcon />}
        <Typography color="black-1" textStyle="b2">
          {data?.likes_count}
        </Typography>
      </Flex>
      <Flex alignItems="center">
        <Flex alignItems="center" gap={4}>
          <SeenIcon />
          <Typography textStyle="b2" color="black-2">
            {data?.views_count} بازدید
          </Typography>
        </Flex>
        <Box width="2px" height="18px" bg="gray-3" mx={8} />
        <Flex>
          <Typography textStyle="b2" color="black-2">
            {timeAgo}
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  );
}
